import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderTransferComponent } from './transfer.component';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    RappiderTransferComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzTransferModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  exports: [
    RappiderTransferComponent
  ]
})
export class RappiderTransferModule { }
